import type { TierKey } from '@/lib/phishtrainer/types'
export type { TierKey }

export const TIER_PALETTE: Record<TierKey, {
  rim: [string, string, string]
  shield: [string, string]
  shieldStroke: string
  star: string
  crown?: string
  crownStroke?: string
  gem?: string
  glow: string
}> = {
  bronze:   { rim: ['#b45309', '#f59e0b', '#d97706'], shield: ['#92400e', '#7c2d12'], shieldStroke: '#fbbf24', star: '#fde68a', glow: '#f59e0b' },
  silver:   { rim: ['#cbd5e1', '#f1f5f9', '#94a3b8'], shield: ['#475569', '#1e293b'], shieldStroke: '#e2e8f0', star: '#f8fafc', glow: '#cbd5e1' },
  gold:     { rim: ['#ca8a04', '#fcd34d', '#f59e0b'], shield: ['#78350f', '#451a03'], shieldStroke: '#fde68a', star: '#fef3c7', glow: '#fbbf24' },
  diamond:  { rim: ['#22d3ee', '#818cf8', '#6366f1'], shield: ['#1e40af', '#312e81'], shieldStroke: '#67e8f9', star: '#e0f2fe', crown: '#67e8f9', crownStroke: '#22d3ee', gem: '#f0abfc', glow: '#22d3ee' },
  rockstar: { rim: ['#ec4899', '#f97316', '#facc15'], shield: ['#7e22ce', '#4c1d95'], shieldStroke: '#fbbf24', star: '#fef3c7', crown: '#fde047', crownStroke: '#f59e0b', gem: '#ec4899', glow: '#ec4899' },
}
